import { useEffect } from 'react';
import useEvent from 'use-event-callback';

export const usePress = (key: string, callback: () => void) => {
  const cb = useEvent(callback);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key?.toLowerCase() === key.toLowerCase()) {
        cb();
      }
    };

    document.addEventListener('keydown', handler);

    return () => document.removeEventListener('keydown', handler);
  }, [cb, key]);
};
